import { createActionTypes } from 'utils/action/actionTypes';

export const GET_ALL_MODULES = createActionTypes('GET_ALL_MODULES');
export const UPDATE_MODULE = createActionTypes('UPDATE_MODULE');
